import { render, staticRenderFns } from "./WsReportsForm.vue?vue&type=template&id=7d7f660b&scoped=true"
import script from "./WsReportsForm.vue?vue&type=script&lang=js"
export * from "./WsReportsForm.vue?vue&type=script&lang=js"
import style0 from "./WsReportsForm.vue?vue&type=style&index=0&id=7d7f660b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f660b",
  null
  
)

export default component.exports